import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

// Frontend admin gate — server-side `require_admin!` is the actual
// security boundary; this just keeps the UI clean for non-admins so
// they don't see admin nav links or 403-trash an admin route.
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, status } = useAuth();
  if (status !== "authenticated") return null;
  if (!user?.admin) return <Navigate to="/workspace" replace />;
  return <>{children}</>;
}
